import createTsdApi from "../../../client-api/createTsdApi";
import {
  CustomerOrgContact,
  CustomerOrgContactCreateParams,
  CustomerOrgContactQueryParams,
  CustomerOrgContactUpdateParams,
} from "../../../entities/CustomerOrgContact/customerOrgContact";
import { TsdSearchParam } from "../fetch";

const customerOrgContactApi = createTsdApi<
  CustomerOrgContact,
  CustomerOrgContactQueryParams,
  CustomerOrgContactCreateParams,
  CustomerOrgContactUpdateParams
>("customer-org-contacts", (_params) => {
  const search: TsdSearchParam<CustomerOrgContactQueryParams>[] = [];

  return search;
});

export default customerOrgContactApi;
